import { Injectable } from '@angular/core';
import { UtilityService } from '../utility.service';
import { BaseFormService } from '../BaseFormService';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class OtherTuitionReimbursementPaymentService extends BaseFormService {
	constructor(httpClient: HttpClient, utilityService: UtilityService) {
		super(
			`${environment.apiUrl}forms/clients/$$clientId$$/other-tuition-reimbursement-payment`,
			httpClient,
			utilityService
		);
	}

	getFormsForClient(clientId: string): Observable<any[]> {
		return this.httpClient.get<any[]>(`${this.getUrl(clientId)}/GetPreApprovalByClient`).pipe();
	}

	submitForApproval(clientId: string, id: any, userId: string): Observable<any> {
		return this.httpClient
			.post<any>(`${this.getUrl(clientId)}/${id}/approval`, {
				userId,
			})
			.pipe();
	}

	updateAutoPay(clientId: string, formId: string, autoPay: boolean): Observable<any> {
		return this.httpClient.patch(`${this.getUrl(clientId)}/${formId}/autopay`, autoPay).pipe();
	}
}
